import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table"
}
const _hoisted_2 = { class: "table__cell-inner" }
const _hoisted_3 = {
  key: 0,
  class: "table__cell-warn"
}
const _hoisted_4 = { class: "table__cell table__head" }
const _hoisted_5 = {
  key: 1,
  class: "table__cell-sub table__cell"
}
const _hoisted_6 = { class: "table__cell-time" }

import {useStore} from "vuex";
import {computed} from "vue";
import { Working, WTime } from '@/types';
import { State } from "@/store/user/types";
import { addDays, parse } from 'date-fns';
import { ru } from 'date-fns/locale';
import { extractDatePartsGURV } from '@/utils/gurv';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaMainTableHead',
  setup(__props) {

const store = useStore<State>()
const days = computed<string[]>(() => {
  return store.getters['getCurrentDays']
})

const currentMonth = computed<number>(() => {
  return store.getters['getCurrentMonthNumber']
})

// Вычисляемое свойство для сортировки расписания
const sortedTimeScheduleData = computed(() => {
  const timeScheduleData = store.getters['data/timeSchedule'] as WTime[];
  if (!timeScheduleData) return null;

  return Object.entries(timeScheduleData).sort(([a], [b]) => {
    const dayA = parseInt(a.split('.')[0], 10);
    const dayB = parseInt(b.split('.')[0], 10);
    return dayA - dayB;
  });
});

// Проверка на сегодняшний день
const isToday = (index: number) => {
  // Добавлена проверка из-за ошибки с датами после logout
  if (!currentMonth.value) return false

  const today = new Date();
  const actualMonth = (today.getMonth() + 1).toString()
  const month = currentMonth.value.toString();

  return today.getDate() === (index + 1) && actualMonth === month
}

const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

const isWFMReaderRole = computed<boolean>(() => {
  return store.getters['getWFMReaderRole']
})

const isGurvRole = computed<boolean>(() => {
  return store.getters['getGurvRole']
})

const frvDedicatedHours = computed<number>(() => {
  return store.getters['data/coreStaff'] && store.getters['data/coreStaff'].dedicated
})

const isPrevMonthActive = computed<boolean>(() => {
  return !!localStorage.getItem('activePrevMonth')
})

// Предупреждения о том, что часы заполнены некорректно
const isDayFullMsg = (index: number) => {
  const dayFullType = getDayFullType(index);

  // Выбранный месяц не прошедший, в этом месяце есть frvMainPlan и на этом дне "dayFull": "less"
  if (!isPrevMonthActive.value && (frvDedicatedHours.value > 0 && dayFullType === 'less')) {
    return 'Добавьте смены на день'
  }
  // В остальных случаях проверяем только "dayFull"
  return dayFullType === 'more' ? 'Сократите часы смен' : '';
}

// Определение статуса дня
const getDayFullType = (index: number): string => {
  const sortedData = sortedTimeScheduleData.value;
  // Убрано отображение для WFM_READER (OMR-3070)
  if ((isWFMReaderRole.value || isOfflineDirectorRole.value) || !sortedData || !sortedData[index]) return '';

  const parsedDate = parse(sortedTimeScheduleData.value[index][0], "dd.MM.yyyy", new Date(), { locale: ru });

  // Игнорируем статус дня т.к. 2 и 17 числа можно создавать смены только на вчера (OMR-3438)
  const { creatingDay, creatingMonth, currentMonthNumber, currentDay } = extractDatePartsGURV(sortedTimeScheduleData.value[index][0]);
  const isSalaryDays = currentDay >= 17 && (creatingDay === 15 && creatingMonth === currentMonthNumber)


  if (isGurvRole.value) {
    return sortedData[index][1].dayFull || '';
  }

  if (!isSalaryDays && (addDays(new Date(), -3).getTime() < parsedDate.getTime())) {
    return sortedData[index][1].dayFull || '';
  }

  return ''
};

// Проверка на выходной день
const isDayOff = (item: Working): boolean => item.start === '00:00' && item.end === '00:00';

const timeSchedule = computed<Working[] | null>(() => {
  if (!sortedTimeScheduleData.value) return null;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return sortedTimeScheduleData.value.map(([_, item]) => {
    const typedItem = item as WTime;
    if (typedItem.actualWorkTime && !typedItem.emptySchedule) {
      const [start, end] = typedItem.actualWorkTime.split('-')
      const dayFull = typedItem.dayFull || ''
      return { start, end, dayFull }

    } else if (typedItem.emptySchedule) {
      // Расписание отсутствует
      return { start: '--:--', end: '--:--' }
    }
    return { start: '00:00', end: '00:00' }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (timeSchedule.value)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (item, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: item + index,
                class: _normalizeClass({'today': isToday(index), [getDayFullType(index)]: true})
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (isDayFullMsg(index))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(isDayFullMsg(index)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item) + ", " + _toDisplayString(index + 1), 1)
                ])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeSchedule.value, (item, i) => {
              return (_openBlock(), _createElementBlock("td", {
                key: `${item.start}-${i}`,
                class: _normalizeClass({'today': isToday(i)})
              }, [
                (isDayOff(item))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["table__cell-sub table__cell table__cell-dayoff", {'today': isToday(i)}])
                    }, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("div", { class: "table__cell-time" }, "Выходной", -1)
                    ]))], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(item.start), 1),
                        (item.end !== '--:--')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_vita_icon, {
                                class: "table__cell-icon",
                                name: "arrow-sm"
                              }),
                              _createElementVNode("span", null, _toDisplayString(item.end), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ], 2))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})